import { useMemo } from 'react'

import { useOperativeTokenCatalog } from '@/features/tokens/useOperativeTokenCatalog'

import { Currency } from '../../sdk'

import { resolveSwapCurrencyFromCatalog } from './swapCatalog'
import { useSwapCatalogChainId } from './useSwapCatalogChainId'

/** Resuelve un id de moneda contra el catálogo operativo (PC + Nutrimatic). */
export function useResolveSwapCurrency(currencyId: string | undefined): Currency | undefined {
  const chainId = useSwapCatalogChainId()
  const { entries } = useOperativeTokenCatalog()

  return useMemo(
    () => resolveSwapCurrencyFromCatalog(chainId, currencyId, entries),
    [chainId, currencyId, entries],
  )
}
